module.exports = __webpack_public_path__ + "static/kv-bg-a3bec68677ea741e723b9d34098f5846.png";